import { APPRADIO_ORIGIN } from "../lib/origins";
export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="rp-footer">
      <div className="rp-footer-inner">
        <p className="rp-footer-brand">
          Radios<em>.PRO</em>
        </p>
        <p className="rp-footer-cta">
          Encontre, ouça e favorite as melhores rádios online. Não tem uma radio? Crie o seu app em{" "}
          <a href={`${APPRADIO_ORIGIN}/crie_sua_radio`} target="_blank" rel="noopener">
            appradio.pro
          </a>
          .
        </p>
        <nav className="rp-footer-links" aria-label="Footer">
          <a href="/">Inicio</a>
          <a href={`${APPRADIO_ORIGIN}/contato`} target="_blank" rel="noopener">
            Contato
          </a>
          <a href={`${APPRADIO_ORIGIN}/politicas`} target="_blank" rel="noopener">
            Politicas
          </a>
          <a href={`${APPRADIO_ORIGIN}/etica`} target="_blank" rel="noopener">
            Etica
          </a>
        </nav>
        <p className="rp-footer-copy">&copy; {year} Radios.PRO</p>
      </div>
    </footer>
  );
}
